/**
 * Histopathology Billing Table.
 * Migrated from admin4.0 HistoBillingTbl.js – same flow, design, layout and logic.
 */
import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Dialog,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Modal,
  Radio,
  RadioGroup,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import AddBoxIcon from "@mui/icons-material/AddBox";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import EditIcon from "@mui/icons-material/Edit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import DescriptionIcon from "@mui/icons-material/Description";
import ToastMsg from "../../Components/ToastMsg/ToastMsg";
import CommonValidation from "../../Utility/CommonValidation";
import { CurrencySymbol, TXN_MSG_MAX, TXN_MSG_MAX_LEN } from "../../Utility/Constants";
import { ImagePaths } from "../../Utility/ImagePaths";
import RestAPIService from "../../Utility/Services/RestAPIService";
import { Serviceurls } from "../../Utility/API/Serviceurls";
import { getCachevalue } from "../../Utility/Services/CacheProviderService";
import Loader from "../../Components/Loader";
import "../../Styles/Configuration.css";

const COMMON_STYLES = {
  HEIGHT: "2.5vw",
  FONT_SIZE_XS: "0.7vw",
  FONT_SIZE_SM: "0.75vw",
  FONT_SIZE_MD: "0.8vw",
  FONT_SIZE_L: "0.85vw",
  FONT_WEIGHT: 600,
};

const INPUT_SIZE_SX = {
  '& .MuiInputBase-root': { height: '2.25vw' },
  '& .MuiInputBase-input': { fontSize: '0.85vw', padding: '0.3vw 0.6vw' },
  '& .MuiSelect-select': { fontSize: '0.85vw', padding: '0.3vw 0.6vw' },
  '& .MuiInputLabel-root': { fontSize: '0.85vw', top: '-0.3vw', marginTop: '0.1vw' },
  '& .MuiInputLabel-shrink': { top: '0.05vw' },
  '& .MuiOutlinedInput-notchedOutline legend': { fontSize: '0.65vw' },
  '& .MuiAutocomplete-endAdornment': { top: '50%', transform: 'translateY(-50%)' },
  '& .MuiAutocomplete-endAdornment .MuiSvgIcon-root': { fontSize: '1.1vw' },
};

const DEFAULT_SERVICE_DATA = {
  rate_per_unit: "",
  unit: 1,
  unit_type: "Nos",
  total_amt: "",
  total_with_discount: "",
  doctor_amt: "",
  doctor_percent: "",
  old_doctor_amt: "",
  new_doctor_amt: "",
  hospital_amt: "",
  hospital_percent: "",
  old_hospital_amt: "",
  new_hospital_amt: "",
  service_name: "",
  service_head_name: "",
  service_code: "",
  service_head_code: "",
  edit_unit: false,
  edit_amount: false,
  edit_discount: false,
  doctor_name: "",
  doctor_id: "",
  doc_discount_amt: "",
  doc_discount_percent: "",
  hos_discount_amt: "",
  hos_discount_percent: "",
  concession_amt: "",
  concession_percent: "",
  gst_percent: 0,
  concession_comments: "",
  service_details_id: "",
  gst_amount: "",
  sgst_amount: "",
  cgst_amount: "",
  igst_amount: "",
  taxable_amount: "",
  sub_total_amount: "",
  concession_percent_w_r: "",
  doctor_percent_w_r: "",
  hospital_percent_w_r: "",
  module_type: "",
  is_hospital: false,
  service_head_id: null,
  op_order_number: "",
  id: null,
};


export default function HistoBillingTbl(props) {
  const {
    quickBillClear,
    patientId,
    getOrCreatePatientId,
    onBillSuccessClear,
    isExistingBill = false,
    searchResultSpecimen,
    nxtId,
    employerId = "",
    employeeId = "",
    corporateList = [],
    onEmployerIdChange,
    onEmployeeIdChange,
  } = props || {};
  const [isLoader, setIsLoader] = useState(false);
  const [openPopup, setOpenPopup] = useState(null);
  const [popupValues, setPopupValues] = useState({});
  const loggedInUserInfo = JSON.parse(getCachevalue("loggedInUserInfo") || "{}");
  const [loginInfo] = useState(loggedInUserInfo);
  const [duplicateCount, setDuplicateCount] = useState({});
  const [searchKey, setSearchKey] = useState("");
  const [message, setMessage] = useState({
    isErrorMsgText: "",
    successMsgText: "",
    isErrorMsg: false,
    successMsg: false,
  });
  const [billSuccessPopup, setBillSuccessPopup] = useState({ open: false, label: "" });
  const [billing, setBilling] = useState({
    billingList: [],
    dupBillList: "[]",
    SpecimenList: [],
    serviceSugg: [],
    allServiceConfigList: [],
    selected_specimen: null,
    selected_specimen_id: null,
    selected_service: null,
    selected_bill_doc: null,
    service_data: { ...DEFAULT_SERVICE_DATA },
    overall_data: {
      sub_total: "",
      round_off: "",
      payable_amt: "",
      taxable_amount: "",
      gst_amount: "",
      concession_applicable: "",
      actual_sub_total_amount: "",
    },
    isEdit: false,
    selectedIndex: null,
    selectedServiceIndex: null,
    selectedSubIndex: null,
    openDeletePopup: false,
    deleted_service: null,
    deletedIndex: null,
    cancelled_ids: [],
    overallDiscount: { discount_amount: "", discount_percentage: "", discount_percentage_w_r: "" },
  });
  const [requestState] = useState({
    fromApprover: false,
    fromBillConvert: false,
    modifyApprover: false,
  });
  const [paymentMode, setPaymentMode] = useState({
    isCash: false,
    isCard: false,
    isUPI: false,
    isBank: false,
    isCheque: false,
    cash_amt: "",
    card_amt: "",
    upi_amt: "",
    bank_amt: "",
    cheque_amt: "",
    card_no: "",
    bank_no: "",
    upi_no: "",
    cheque_no: "",
  });
  const [creditType, setCreditType] = useState(false);
  const [patientCreditType, setPatientCreditType] = useState("patientcredit");
  const [selectedCorporate, setSelectedCorporate] = useState(null);
  const [selectedInsurance, setSelectedInsurance] = useState(null);
  const [policyno, setPolicyno] = useState("");
  const [employeeNo, setEmployeeNo] = useState("");
  const [corporateData, setCorporateData] = useState([]);
  const [insuranceData, setInsuranceData] = useState([]);
  const [refferals, setRefferals] = useState({
    refferalList: [],
    type: "self",
    doctor: "",
    hospital: "",
  });

  const errorMessage = (msg) =>
    setMessage((prev) => ({ ...prev, isErrorMsg: true, isErrorMsgText: msg }));
  const successMessage = (msg) =>
    setMessage((prev) => ({ ...prev, successMsg: true, successMsgText: msg }));
  const msgClose = () =>
    setMessage((prev) => ({ ...prev, isErrorMsg: false, isErrorMsgText: "", successMsg: false, successMsgText: "" }));

  const getreferralDoc = useCallback(() => {
    RestAPIService.getAll(Serviceurls.HISTO_REFERRAL_DOCTOR)
      .then((res) => {
        if (res?.data?.status === "success")
          setRefferals((prev) => ({ ...prev, refferalList: res.data.data || [] }));
      })
      .catch((err) => errorMessage(err?.response?.data?.message || err?.message));
  }, []);

  const getSpecimenList = useCallback(() => {
    RestAPIService.getAll(Serviceurls.HISTOPATHOLOGY_SPECIMEN)
      .then((res) => {
        if (res?.data?.status === "success") {
          const active = (res.data.data || []).filter((item) => item.is_active);
          setBilling((prev) => ({ ...prev, SpecimenList: active }));
        }
      })
      .catch((err) => errorMessage(err?.response?.data?.message || err?.message));
  }, []);

  const getServiceConfigList = useCallback(() => {
    const params = new URLSearchParams({
      module_type: "HISTOPATHOLOGY",
      service_head_id: "",
      service_details_id: "",
      service_head: "",
      service_name: "",
      service_head_code: "",
      charge_type: "Normal",
    });
    RestAPIService.getAll(Serviceurls.NEW_DEPARTMENT_MASTER + "?" + params.toString())
      .then((res) => {
        if (res?.data?.status === "success") {
          const raw = res.data.data || [];
          const mapped = raw.map((row) => {
            const headDetails = row.service_head_details ?? "";
            const serviceHead = headDetails.includes(" - ") ? headDetails.split(" - ").slice(1).join(" - ").trim() : headDetails;
            return {
              ...row,
              service_head: row.service_head ?? serviceHead,
              charge_id: row.service_charge_id,
              doctor_share_amount: row.doctor_share_amount ?? 0,
              hospital_share_amount: row.hospital_share_amount ?? 0,
              doctor_share_percent: row.doctor_share_percent ?? 0,
              hospital_share_percent: row.hospital_share_percent ?? 0,
            };
          });
          setBilling((prev) => ({ ...prev, allServiceConfigList: mapped }));
        }
      })
      .catch((err) => errorMessage(err?.response?.data?.message || err?.message));
  }, []);

  useEffect(() => {
    getreferralDoc();
    getSpecimenList();
    getServiceConfigList();
  }, [getreferralDoc, getSpecimenList, getServiceConfigList]);

  const billingCalculation = useCallback(() => {
    const list = billing.billingList || [];
    if (list.length === 0) {
      setBilling((prev) => ({
        ...prev,
        overall_data: {
          ...prev.overall_data,
          sub_total: 0,
          round_off: 0,
          payable_amt: 0,
          taxable_amount: 0,
          gst_amount: 0,
          concession_applicable: 0,
          actual_sub_total_amount: 0,
        },
      }));
      return;
    }
    const calData = list.reduce(
      (acc, el) => {
        acc.sub_total += +(el.total_with_discount ?? 0);
        acc.actual_sub_total_amount += +(el.sub_total_amount ?? 0);
        acc.taxable_amount += +(el.taxable_amount ?? 0);
        acc.gst_amount += +(el.gst_amount ?? 0);
        acc.concession_applicable += +(el.concession_applicable ?? 0);
        return acc;
      },
      { sub_total: 0, taxable_amount: 0, gst_amount: 0, concession_applicable: 0, actual_sub_total_amount: 0 }
    );
    calData.sub_total = +CommonValidation.formatAmount(calData.sub_total);
    calData.taxable_amount = +CommonValidation.formatAmount(calData.taxable_amount);
    calData.gst_amount = +CommonValidation.formatAmount(calData.gst_amount);
    calData.concession_applicable = +CommonValidation.formatAmount(calData.concession_applicable);
    calData.actual_sub_total_amount = +CommonValidation.formatAmount(calData.actual_sub_total_amount);
    const discountAmt = +(billing.overallDiscount?.discount_amount ?? 0);
    const finalPay = calData.taxable_amount + calData.gst_amount - discountAmt;
    calData.round_off = CommonValidation.formatAmount(Math.round(finalPay) - finalPay);
    calData.payable_amt = Math.round(finalPay);
    setBilling((prev) => ({ ...prev, overall_data: { ...prev.overall_data, ...calData } }));
  }, [billing.billingList, billing.overallDiscount?.discount_amount]);

  useEffect(() => {
    if (billing.billingList?.length > 0) {
      billingCalculation();
    } else if (billing.billingList?.length === 0) {
      setBilling((prev) => ({
        ...prev,
        overall_data: {
          ...prev.overall_data,
          sub_total: 0,
          round_off: 0,
          payable_amt: 0,
          taxable_amount: 0,
          gst_amount: 0,
          concession_applicable: 0,
        },
      }));
    }
  }, [billing.billingList, billing.overallDiscount?.discount_amount, billing.overallDiscount?.discount_percentage_w_r, billingCalculation]);

  useEffect(() => {
    if (billing.billingList?.length === 0 && !isExistingBill) {
      setBilling((prev) => ({ ...prev, selected_specimen: null, selected_specimen_id: null }));
    }
  }, [billing.billingList?.length, isExistingBill]);

  useEffect(() => {
    if (!searchResultSpecimen?.specimen_id) return;
    const specimenOption = {
      id: searchResultSpecimen.specimen_id,
      specimen_type: searchResultSpecimen.specimen_type ?? "",
      specimen_code: searchResultSpecimen.specimen_code ?? "",
    };
    setBilling((prev) => {
      const list = prev.SpecimenList || [];
      const exists = list.some((s) => s.id === searchResultSpecimen.specimen_id);
      const nextList = exists ? list : [specimenOption, ...list];
      return {
        ...prev,
        SpecimenList: nextList,
        selected_specimen: specimenOption,
        selected_specimen_id: searchResultSpecimen.specimen_id,
      };
    });
  }, [searchResultSpecimen?.specimen_id]);

  const effectiveSpecimenId = billing.selected_specimen_id ?? billing.billingList?.[0]?.specimen_id ?? null;
  const filteredServiceSugg = useMemo(() => {
    const list = billing.allServiceConfigList || [];
    if (!list.length) return [];
    if (effectiveSpecimenId != null) return list.filter((s) => s.specimen_id === effectiveSpecimenId);
    return list;
  }, [billing.allServiceConfigList, effectiveSpecimenId]);

  const initialOverallData = {
    sub_total: "",
    round_off: "",
    payable_amt: "",
    taxable_amount: "",
    gst_amount: "",
    net_amount: "",
    concession_applicable: "",
    actual_sub_total_amount: "",
  };
  const initialPaymentMode = {
    isCash: false,
    isCard: false,
    isUPI: false,
    isBank: false,
    isCheque: false,
    cash_amt: "",
    card_amt: "",
    upi_amt: "",
    bank_amt: "",
    cheque_amt: "",
    card_no: "",
    bank_no: "",
    upi_no: "",
    cheque_no: "",
  };

  useEffect(() => {
    if (quickBillClear) {
      setBilling((prev) => ({
        ...prev,
        billingList: [],
        dupBillList: "[]",
        cancelled_ids: [],
        selected_service: null,
        selected_specimen: null,
        selected_specimen_id: null,
        service_data: { ...DEFAULT_SERVICE_DATA },
        isEdit: false,
        selectedIndex: null,
        overall_data: initialOverallData,
        overallDiscount: { discount_amount: "", discount_percentage: "", discount_percentage_w_r: "" },
      }));
      setPaymentMode(initialPaymentMode);
      setRefferals((prev) => ({ ...prev, type: "self", doctor: "", hospital: "" }));
    }
  }, [quickBillClear]);

  const onOpenPopupHandler = (type) => {
    setOpenPopup(type);
    setPopupValues({
      ...billing.service_data,
      concession_amt: billing.service_data?.concession_amt,
      concession_percent: billing.service_data?.concession_percent,
      concession_comments: billing.service_data?.concession_comments,
    });
  };

  const onClickUnitHandler = useCallback(
    (type) => {
      setBilling((prev) => {
        const sd = { ...prev.service_data };
        if (type === "increase") sd.unit = (sd.unit || 1) + 1;
        else if (type === "decrease") sd.unit = Math.max(1, (sd.unit || 1) - 1);
        const baseTotal = sd.unit * (sd.rate_per_unit || 0);
        if (sd.doctor_amt || sd.hospital_amt) {
          const oldDoc = CommonValidation.getDiscountAmountWithRound(sd.doctor_percent, baseTotal);
          const oldHos = CommonValidation.getDiscountAmountWithRound(sd.hospital_percent, baseTotal);
          const disDoc = CommonValidation.getDiscountAmountWithRound(sd.doc_discount_percent, oldDoc);
          const disHos = CommonValidation.getDiscountAmountWithRound(sd.hos_discount_percent, oldHos);
          const conTlt = +disDoc + +disHos;
          sd.total_amt = baseTotal;
          sd.old_doctor_amt = oldDoc;
          sd.old_hospital_amt = oldHos;
          sd.new_doctor_amt = oldDoc - disDoc;
          sd.new_hospital_amt = oldHos - disHos;
          sd.doctor_amt = oldDoc - disDoc;
          sd.hospital_amt = oldHos - disHos;
          sd.doc_discount_amt = disDoc;
          sd.hos_discount_amt = disHos;
          sd.concession_amt = CommonValidation.formatAmount(conTlt);
          sd.concession_percent = CommonValidation.getDiscountPercentage(conTlt, baseTotal);
          sd.concession_percent_w_r = CommonValidation.getDiscountPercentageWithRound(conTlt, baseTotal);
        } else {
          sd.total_amt = baseTotal;
          sd.concession_amt = CommonValidation.getDiscountAmountWithRound(sd.concession_percent, baseTotal);
        }
        return { ...prev, service_data: sd };
      });
    },
    [billing.service_data]
  );

  const withOutShareHandler = useCallback(
    (e, key) => {
      const value = e.target.value;
      setBilling((prev) => {
        const update = { ...prev.service_data };
        if (key === "rate_per_unit") {
          if (CommonValidation.DecimalNumber(value) || value === "") {
            update.rate_per_unit = value;
            update.total_amt = (update.unit || 1) * (value ? +value : 0);
            update.concession_amt = value ? CommonValidation.getDiscountAmountWithRound(update.concession_percent, update.total_amt) : "";
          }
        } else if (key === "concession_discount_amt") {
          const totalAmt = +(update.total_amt ?? 0);
          if ((CommonValidation.DecimalNumber(value) && +value <= totalAmt) || value === "") {
            update.concession_amt = value;
            update.concession_percent = value ? CommonValidation.getDiscountPercentage(value, update.total_amt) : "";
            update.concession_percent_w_r = value ? CommonValidation.getDiscountPercentageWithRound(value, update.total_amt) : "";
          }
        } else if (key === "concession_discount_percent") {
          if ((CommonValidation.DecimalNumber(value) && value <= 100) || value === "") {
            update.concession_percent = value;
            update.concession_percent_w_r = value;
            update.concession_amt = CommonValidation.getDiscountAmountWithRound(value, update.total_amt);
          }
        }
        return { ...prev, service_data: update };
      });
    },
    [billing.service_data]
  );

  const onEditHandler = (item, index = null, subIndex = null, mainIndex = null) => {
    const specimen = item?.specimen_id && billing.SpecimenList?.length
      ? billing.SpecimenList.find((s) => s.id === item.specimen_id) ?? null
      : null;
    setBilling((prev) => ({
      ...prev,
      selected_service: item,
      selected_bill_doc: item?.doctor_name,
      service_data: { ...item },
      isEdit: true,
      selectedIndex: index,
      selectedSubIndex: subIndex ?? null,
      selectedServiceIndex: mainIndex ?? null,
      selected_specimen: specimen ?? prev.selected_specimen,
      selected_specimen_id: item?.specimen_id ?? prev.selected_specimen_id,
    }));
  };

  const onSelectServiceHandler = (value) => {
    if (!value) return;
    const serviceData = "emergency" in value ? value.emergency : "holiday" in value ? value.holiday : value;
    const sharedFields = {
      rate_per_unit: serviceData.service_charge,
      unit: serviceData.unit ?? 1,
      unit_type: serviceData.unit_type || "Nos",
      total_amt: serviceData.service_charge,
      total_with_discount: serviceData.service_charge,
      doctor_amt: serviceData.doctor_share_amount || "",
      doctor_percent: serviceData.doctor_share_percent || "",
      old_doctor_amt: serviceData.doctor_share_amount || "",
      new_doctor_amt: serviceData.doctor_share_amount || "",
      hospital_amt: serviceData.hospital_share_amount || "",
      hospital_percent: serviceData.hospital_share_percent || "",
      old_hospital_amt: serviceData.hospital_share_amount || "",
      new_hospital_amt: serviceData.hospital_share_amount || "",
      service_name: serviceData.service_name,
      service_head_name: serviceData.service_head,
      service_code: serviceData.service_code,
      service_head_code: serviceData.service_head_code,
      edit_unit: serviceData.edit_unit ?? true,
      edit_amount: serviceData.edit_amount ?? true,
      edit_discount: serviceData.edit_discount ?? true,
      doctor_name: serviceData.doctor_name || "",
      doctor_id: serviceData.doctor_id || "",
      gst_percent: serviceData.gst_percent || 0,
      service_details_id: serviceData.service_details_id,
      charge_id: serviceData.charge_id,
      review_days: serviceData.review_days,
      review_count: serviceData.review_count,
      module_type: serviceData.module_type,
      doctor_percent_w_r: +(serviceData.doctor_share_percent?.toFixed(2) || 0),
      hospital_percent_w_r: +(serviceData.hospital_share_percent?.toFixed(2) || 0),
      start_date: new Date(),
      end_date: null,
      is_hospital: serviceData.is_hospital || false,
      service_head_id: serviceData.service_head_id,
      op_order_number: serviceData.op_order_number || "",
      doc_discount_amt: "",
      doc_discount_percent: "",
      hos_discount_amt: "",
      hos_discount_percent: "",
      concession_amt: "",
      concession_percent: "",
      concession_percent_w_r: "",
      specimen_id: serviceData.specimen_id ?? null,
    };
    if (serviceData.membership_discount_percentage) {
      sharedFields.concession_percent = serviceData.membership_discount_percentage;
      sharedFields.concession_percent_w_r = serviceData.membership_discount_percentage;
      sharedFields.concession_amt = CommonValidation.getDiscountAmountWithRound(
        serviceData.membership_discount_percentage,
        sharedFields.total_amt
      );
      sharedFields.total_with_discount = sharedFields.total_amt - sharedFields.concession_amt;
    }
    setBilling((prev) => {
      const next = {
        ...prev,
        selected_service: value,
        service_data: { ...prev.service_data, ...sharedFields },
      };
      if (!prev.selected_specimen_id && serviceData.specimen_id && prev.SpecimenList?.length) {
        const specimen = prev.SpecimenList.find((s) => s.id === serviceData.specimen_id);
        if (specimen) {
          next.selected_specimen = specimen;
          next.selected_specimen_id = specimen.id;
        }
      }
      return next;
    });
  };

  const clearService = () => {
    setBilling((prev) => ({
      ...prev,
      selected_service: null,
      service_data: { ...DEFAULT_SERVICE_DATA },
    }));
  };

  const onClearServiceData = () => {
    setBilling((prev) => {
      const next = {
        ...prev,
        selected_service: null,
        service_data: { ...DEFAULT_SERVICE_DATA },
        isEdit: false,
        selectedIndex: null,
        selectedServiceIndex: null,
        selectedSubIndex: null,
      };
      if (!isExistingBill) {
        next.selected_specimen = null;
        next.selected_specimen_id = null;
      }
      return next;
    });
  };

  const checkDuplicate = () => {
    for (let i = 0; i < billing.billingList.length; i++) {
      if (i !== billing.selectedIndex) {
        const el = billing.billingList[i];
        if (
          el?.service_head_code === billing.service_data?.service_head_code &&
          el?.service_code === billing.service_data?.service_code &&
          el?.service_details_id === billing.service_data?.service_details_id
        )
          return "Service Already Exist";
      }
    }
    return null;
  };

  const onAddHandler = () => {
    if (!billing.selected_specimen && !billing.selected_specimen_id) {
      return errorMessage("Please select a Specimen Type");
    }
    if (!billing.selected_service && !billing.service_data?.service_name) {
      return errorMessage("Please select a Service");
    }
    const discountTotal = +billing.service_data.total_amt - +(billing.service_data.concession_amt || 0);
    const isGst = loginInfo?.is_gst_enabled;
    const incGst = isGst ? CommonValidation.calculateTotalWithGST(discountTotal, billing.service_data.gst_percent || 0) : 0;
    const tltGstDiff = isGst ? incGst - discountTotal : 0;
    const sgstCgst = isGst ? tltGstDiff / 2 : 0;
    const service_list = {
      ...billing.service_data,
      specimen_id: billing.selected_specimen_id ?? billing.service_data?.specimen_id ?? null,
      total_with_discount: discountTotal,
      service_with_gst_total_amt: isGst ? CommonValidation.formatAmount(incGst) : discountTotal,
      gst_amount: CommonValidation.formatAmount(tltGstDiff),
      sgst_amount: CommonValidation.formatAmount(sgstCgst),
      cgst_amount: CommonValidation.formatAmount(sgstCgst),
      igst_amount: CommonValidation.formatAmount(tltGstDiff),
      taxable_amount: discountTotal,
      sub_total_amount: billing.service_data.total_amt,
      concession_applicable: billing.service_data.edit_discount
        ? billing.service_data.is_hospital
          ? billing.service_data.new_hospital_amt
          : discountTotal
        : 0,
      module_type: billing.service_data.module_type,
      unit: billing.service_data.unit,
      service_head_id: billing.service_data.service_head_id,
      doctor_id: billing.selected_bill_doc?.doctor_id || billing.service_data.doctor_id,
      doctor_name: billing.selected_bill_doc?.doctor_name || billing.service_data.doctor_name,
      id: billing.service_data?.id ?? null,
      not_from_order: true,
    };
    const err = checkDuplicate();
    if (err) return errorMessage(err);
    setBilling((prev) => {
      const list = [...prev.billingList];
      if (prev.isEdit && prev.selectedIndex != null) {
        list[prev.selectedIndex] = service_list;
      } else {
        list.push(service_list);
      }
      return {
        ...prev,
        billingList: list,
        dupBillList: JSON.stringify(list),
        overallDiscount: { discount_amount: "", discount_percentage: "", discount_percentage_w_r: "" },
      };
    });
    setTimeout(onClearServiceData, 50);
  };

  const handleCheckBox = (e, key) => {
    const checked = e.target.checked;
    setPaymentMode((prev) => ({
      ...prev,
      [key]: checked,
      cash_amt: key === "isCash" && !checked ? "" : prev.cash_amt,
      card_amt: key === "isCard" && !checked ? "" : prev.card_amt,
      upi_amt: key === "isUPI" && !checked ? "" : prev.upi_amt,
      bank_amt: key === "isBank" && !checked ? "" : prev.bank_amt,
      cheque_amt: key === "isCheque" && !checked ? "" : prev.cheque_amt,
      card_no: key === "isCard" && !checked ? "" : prev.card_no,
      bank_no: key === "isBank" && !checked ? "" : prev.bank_no,
      upi_no: key === "isUPI" && !checked ? "" : prev.upi_no,
      cheque_no: key === "isCheque" && !checked ? "" : prev.cheque_no,
    }));
  };

  const payableAmt = +(billing.overall_data?.payable_amt ?? 0);

  useEffect(() => {
    if (getCachevalue("auto_fetch_bill_amount_to_payment") !== "true") return;
    if (!payableAmt) return;
    setPaymentMode((prev) => {
      const { isCash, isCard, isUPI, isBank, isCheque } = prev;
      const count = [isCash, isCard, isUPI, isBank, isCheque].filter(Boolean).length;
      if (count !== 1) return prev;
      return {
        ...prev,
        cash_amt: isCash ? String(payableAmt) : prev.cash_amt,
        card_amt: isCard ? String(payableAmt) : prev.card_amt,
        upi_amt: isUPI ? String(payableAmt) : prev.upi_amt,
        bank_amt: isBank ? String(payableAmt) : prev.bank_amt,
        cheque_amt: isCheque ? String(payableAmt) : prev.cheque_amt,
      };
    });
  }, [
    payableAmt,
    paymentMode.isCash,
    paymentMode.isCard,
    paymentMode.isUPI,
    paymentMode.isBank,
    paymentMode.isCheque,
  ]);

  const onPaymentChange = (key, value) => {
    if (key === "cash_amt" || key === "card_amt" || key === "upi_amt" || key === "bank_amt" || key === "cheque_amt") {
      if (value !== "" && !CommonValidation.DecimalNumber(value)) return;
      if (value !== "" && +value > payableAmt) return;
    }
    setPaymentMode((prev) => ({ ...prev, [key]: value }));
  };

  const payamt = (+(paymentMode.cash_amt || 0)) + (+(paymentMode.card_amt || 0)) + (+(paymentMode.upi_amt || 0)) + (+(paymentMode.bank_amt || 0)) + (+(paymentMode.cheque_amt || 0));

  const buildBillPayload = useCallback(
    (status = "draft", overridePatientId = undefined) => {
      const effectivePatientId = overridePatientId !== undefined ? overridePatientId : patientId;
      const list = billing.billingList || [];
      const referralType = refferals?.type === "doctor" ? "doctor" : "self";
      const overallDiscountAmt = +(billing.overallDiscount?.discount_amount ?? 0);
      const overallDiscountPct = billing.overallDiscount?.discount_percentage_w_r ?? "0";
      const totalNetBeforeBillDiscount = list.reduce(
        (sum, item) => sum + +(item.total_with_discount ?? 0),
        0
      );
      const line_items = list.map((item) => {
        const subTotal = +(item.sub_total_amount ?? item.total_amt ?? 0) || (+(item.unit ?? 1) * +(item.rate_per_unit ?? 0));
        const concessionAmt = +(item.concession_amt ?? 0);
        const netAmt = +(item.total_with_discount ?? 0);
        const discountPct = subTotal > 0 ? CommonValidation.formatAmount((concessionAmt / subTotal) * 100) : "0";
        const lineShareOfBillDiscount =
          totalNetBeforeBillDiscount > 0 && overallDiscountAmt > 0
            ? (netAmt / totalNetBeforeBillDiscount) * overallDiscountAmt
            : 0;
        const billDiscountAmount = +CommonValidation.formatAmount(lineShareOfBillDiscount);
        const billNetAmount = netAmt - billDiscountAmount;
        const billDiscountPct =
          netAmt > 0 && billDiscountAmount !== 0
            ? CommonValidation.formatAmount((billDiscountAmount / netAmt) * 100)
            : "0";
        const serviceDesc = [item.service_name, item.service_code].filter(Boolean).length
          ? `${item.service_name || ""}${item.service_code ? ` (${item.service_code})` : ""}`
          : "";
        const headPart = [item.service_head_name, item.service_head_code].filter(Boolean).length
          ? `${item.service_head_name || ""}${item.service_head_code ? ` (${item.service_head_code})` : ""}`
          : "";
        const service_description = [serviceDesc, headPart].filter(Boolean).join(" - ") || "Service";

        return {
          service_details_id: +(item.service_details_id ?? 0),
          service_description,
          units: +(item.unit ?? 1),
          rate_per_unit: CommonValidation.formatAmount(item.rate_per_unit ?? 0),
          sub_total: CommonValidation.formatAmount(subTotal),
          discount_percentage: discountPct,
          discount_amount: CommonValidation.formatAmount(concessionAmt),
          net_amount: CommonValidation.formatAmount(netAmt),
          bill_discount_percentage: String(billDiscountPct),
          bill_discount_amount: CommonValidation.formatAmount(billDiscountAmount),
          bill_net_amount: CommonValidation.formatAmount(billNetAmount),
          concession: CommonValidation.formatAmount(concessionAmt),
          amount: CommonValidation.formatAmount(billNetAmount),
        };
      });
      const taxableAmount = +(billing.overall_data?.taxable_amount ?? 0) + +(billing.overall_data?.gst_amount ?? 0) - overallDiscountAmt;
      const roundOff = +(billing.overall_data?.round_off ?? 0);
      const payableAmount = +(billing.overall_data?.payable_amt ?? 0);
      const isRegular = status === "regular";
      const receivedAmount = isRegular
        ? +(paymentMode.cash_amt || 0) + +(paymentMode.card_amt || 0) + +(paymentMode.upi_amt || 0) + +(paymentMode.bank_amt || 0) + +(paymentMode.cheque_amt || 0)
        : 0;

      const payload = {
        patient_id: +(effectivePatientId ?? 0),
        referral_type: referralType,
        referred_doctor_id: referralType === "self" ? null : (refferals?.doctor?.id ?? null),
        status,
        line_items,
        overall_concession_amount: CommonValidation.formatAmount(overallDiscountAmt),
        overall_concession_percent: String(overallDiscountPct),
        taxable_amount: CommonValidation.formatAmount(taxableAmount),
        round_off: CommonValidation.formatAmount(roundOff),
        payable_amount: CommonValidation.formatAmount(payableAmount),
        received_amount: CommonValidation.formatAmount(isRegular ? receivedAmount : 0),
        cash_amount: CommonValidation.formatAmount(isRegular ? (paymentMode.cash_amt || 0) : 0),
        upi_amount: CommonValidation.formatAmount(isRegular ? (paymentMode.upi_amt || 0) : 0),
        card_amount: CommonValidation.formatAmount(isRegular ? (paymentMode.card_amt || 0) : 0),
        bank_amount: CommonValidation.formatAmount(isRegular ? (paymentMode.bank_amt || 0) : 0),
        cheque_amount: CommonValidation.formatAmount(isRegular ? (paymentMode.cheque_amt || 0) : 0),
        card_transaction_no: isRegular ? String(paymentMode.card_no || "").trim() : "",
        upi_transaction_no: isRegular ? String(paymentMode.upi_no || "").trim() : "",
        bank_transaction_no: isRegular ? String(paymentMode.bank_no || "").trim() : "",
        cheque_transaction_no: isRegular ? String(paymentMode.cheque_no || "").trim() : "",
        is_existing_bill: !!isExistingBill,
      };
      if (nxtId != null && nxtId !== "") {
        payload.nxt_id = String(nxtId);
      }
      if (status === "credit") {
        const isCorporate = patientCreditType === "corporatecredit";
        payload.credit_type = isCorporate ? "corporate" : "patient";
        payload.corporate_id = isCorporate && employerId !== "" && employerId != null ? Number(employerId) : null;
        payload.employee_id_no = isCorporate ? String(employeeId || "") : "";
      }
      return payload;
    },
    [billing.billingList, billing.overall_data, billing.overallDiscount, refferals, patientId, isExistingBill, paymentMode, nxtId, patientCreditType, employerId, employeeId]
  );

  const handleDraftSave = useCallback(() => {
    if (!patientId) {
      errorMessage("Please create or select a patient first");
      return;
    }
    if (!billing.billingList?.length) {
      errorMessage("Add at least one service to the bill");
      return;
    }
    const payload = buildBillPayload("draft");
    setIsLoader(true);
    RestAPIService.create(payload, Serviceurls.HISTOPATHOLOGY_BILLING_BILL)
      .then((res) => {
        if (res?.data?.status === "success") {
          const billId = res?.data?.data?.id ?? res?.data?.id;
          setBillSuccessPopup({ open: true, label: res?.data?.message || "Bill created successfully", billId });
        }
        setIsLoader(false);
      })
      .catch((err) => {
        setIsLoader(false);
        errorMessage(err?.response?.data?.message || err?.message);
      });
  }, [patientId, billing.billingList?.length, buildBillPayload, errorMessage, successMessage]);

  const handleReceivePayment = useCallback(() => {
    if (!billing.billingList?.length) {
      errorMessage("Add at least one service to the bill");
      return;
    }
    const runBillCreation = (effectivePatientId) => {
      const validationMsg = checkPaymentValidation();
      if (validationMsg) {
        errorMessage(validationMsg);
        return;
      }
      const payload = buildBillPayload("regular", effectivePatientId);
      setIsLoader(true);
      RestAPIService.create(payload, Serviceurls.HISTOPATHOLOGY_BILLING_BILL)
        .then((res) => {
          if (res?.data?.status === "success") {
            const billId = res?.data?.data?.id ?? res?.data?.id;
            setBillSuccessPopup({ open: true, label: res?.data?.message || "Payment received successfully", billId });
          }
          setIsLoader(false);
        })
        .catch((err) => {
          setIsLoader(false);
          errorMessage(err?.response?.data?.message || err?.message);
        });
    };
    if (typeof getOrCreatePatientId === "function") {
      setIsLoader(true);
      getOrCreatePatientId()
        .then((resolvedId) => {
          if (resolvedId) {
            runBillCreation(resolvedId);
          } else {
            setIsLoader(false);
            errorMessage("Patient could not be created");
          }
        })
        .catch(() => {
          setIsLoader(false);
        });
      return;
    }
    if (patientId) {
      runBillCreation(patientId);
      return;
    }
    errorMessage("Please create or select a patient first");
  }, [patientId, billing.billingList?.length, buildBillPayload, getOrCreatePatientId, errorMessage, successMessage]);

  const handleBillPrint = useCallback(() => {
    const billId = billSuccessPopup.billId;
    if (billId == null || billId === "") {
      errorMessage("Bill ID not available for print.");
      return;
    }
    const url = `${Serviceurls.HISTOPATHOLOGY_BILL_PRINT}?bill_id=${encodeURIComponent(billId)}`;
    RestAPIService.PrintPDF(url)
      .then((response) => {
        const file = new Blob([response.data], { type: "application/pdf" });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      })
      .catch((err) => {
        errorMessage(err?.response?.data?.message || err?.message || "Failed to load bill print.");
      });
  }, [billSuccessPopup.billId, errorMessage]);

  const fullAmountEntered = () => {
    const hasMode = paymentMode.isCash || paymentMode.isCard || paymentMode.isUPI || paymentMode.isBank || paymentMode.isCheque;
    if (!hasMode || payamt !== payableAmt || payableAmt <= 0) return false;
    if (!CommonValidation.isTransactionNumberMandatory()) return true;
    const cardAmt = +(paymentMode.card_amt || 0);
    const upiAmt = +(paymentMode.upi_amt || 0);
    const bankAmt = +(paymentMode.bank_amt || 0);
    const chequeAmt = +(paymentMode.cheque_amt || 0);
    const cardNo = (paymentMode.card_no || "").trim();
    const upiNo = (paymentMode.upi_no || "").trim();
    const bankNo = (paymentMode.bank_no || "").trim();
    const chequeNo = (paymentMode.cheque_no || "").trim();
    const refsValid =
      (cardAmt === 0 || cardNo !== "") &&
      (upiAmt === 0 || upiNo !== "") &&
      (bankAmt === 0 || bankNo !== "") &&
      (chequeAmt === 0 || chequeNo !== "");
    if (!refsValid) return false;
    const minLenValid =
      (cardNo === "" || cardNo.length >= TXN_MSG_MAX_LEN) &&
      (upiNo === "" || upiNo.length >= TXN_MSG_MAX_LEN) &&
      (bankNo === "" || bankNo.length >= TXN_MSG_MAX_LEN) &&
      (chequeNo === "" || chequeNo.length >= TXN_MSG_MAX_LEN);
    return minLenValid;
  };

  const checkPaymentValidation = () => {
    if (CommonValidation.isTransactionNumberMandatory()) {
      const cardAmt = +(paymentMode.card_amt || 0);
      const upiAmt = +(paymentMode.upi_amt || 0);
      const bankAmt = +(paymentMode.bank_amt || 0);
      const chequeAmt = +(paymentMode.cheque_amt || 0);
      const cardNo = (paymentMode.card_no || "").trim();
      const upiNo = (paymentMode.upi_no || "").trim();
      const bankNo = (paymentMode.bank_no || "").trim();
      const chequeNo = (paymentMode.cheque_no || "").trim();
      if (
        (cardAmt !== 0 && cardNo === "") ||
        (upiAmt !== 0 && upiNo === "") ||
        (bankAmt !== 0 && bankNo === "") ||
        (chequeAmt !== 0 && chequeNo === "")
      ) {
        return "Please, Enter Reference Number";
      }
    }
    const cardNo = (paymentMode.card_no || "").trim();
    const upiNo = (paymentMode.upi_no || "").trim();
    const bankNo = (paymentMode.bank_no || "").trim();
    const chequeNo = (paymentMode.cheque_no || "").trim();
    if (
      (cardNo !== "" && cardNo.length < TXN_MSG_MAX_LEN) ||
      (upiNo !== "" && upiNo.length < TXN_MSG_MAX_LEN) ||
      (bankNo !== "" && bankNo.length < TXN_MSG_MAX_LEN) ||
      (chequeNo !== "" && chequeNo.length < TXN_MSG_MAX_LEN)
    ) {
      return TXN_MSG_MAX;
    }
    return null;
  };

  const cashTextBox = (key, values, label, Icon) => (
    <TextField
      size="small"
      sx={{ width: "10dvw", mt: "0.5rem", ...INPUT_SIZE_SX }}
      value={values}
      label={`${label} (${CurrencySymbol})`}
      onChange={(e) => onPaymentChange(key, e.target.value)}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <img src={Icon?.default ?? Icon} alt={label} className="eMed_action_img_small" style={{ width: "1.2vw", height: "1.2vw" }} />
          </InputAdornment>
        ),
      }}
    />
  );

  const referenceTextBox = (key, values) => (
    <TextField
      size="small"
      sx={{ width: "13dvw", mt: "0.5rem", ml: "0.5rem", ...INPUT_SIZE_SX }}
      value={values}
      label={`Reference Number${CommonValidation.isTransactionNumberMandatory() ? " *" : ""}`}
      onChange={(e) => onPaymentChange(key, e.target.value)}
    />
  );

  const renderLftContent = () => (
    <Box component="div" sx={{ backgroundColor: "white", position: "relative", borderRadius: "6px", boxShadow: "0 1px 3px rgba(0,0,0,0.08)", display: "flex", flexDirection: "column", height: "100%" }}>
      {/* Referral Row */}
      <Box display="flex" alignItems="center" gap="0.8vw" sx={{ px: "0.8vw", py: "0.6vh", borderBottom: "1px solid #eee" }}>
        <FormControl size="small" sx={{ width: "10vw", ...INPUT_SIZE_SX, "& .MuiInputLabel-root": { overflow: "visible", fontSize: '0.85vw', top: '-0.3vw', marginTop: '0.1vw' } }}>
          <InputLabel>Referred Type</InputLabel>
          <Select
            value={refferals?.type || "self"}
            label="Referred Type"
            onChange={(e) => setRefferals({ ...refferals, type: e.target.value, doctor: "", hospital: "" })}
          >
            <MenuItem value="self">Self</MenuItem>
            <MenuItem value="doctor">Doctor</MenuItem>
          </Select>
        </FormControl>
        <Autocomplete
          freeSolo
          disabled={refferals?.type === "self"}
          size="small"
          sx={{ flex: 1, ...INPUT_SIZE_SX }}
          options={refferals?.refferalList || []}
          getOptionLabel={(opt) =>
            typeof opt === "string" ? opt : opt?.specialization ? `${opt?.name} - ${opt?.specialization}` : opt?.name || ""
          }
          value={refferals?.doctor || null}
          onChange={(e, newValue) =>
            setRefferals((prev) => ({ ...prev, doctor: newValue, hospital: newValue?.hospital_name || "" }))
          }
          renderInput={(params) => <TextField {...params} label="Select Referred Doctor" />}
        />
        <TextField
          size="small"
          value={refferals?.hospital || ""}
          disabled={refferals?.type === "self"}
          inputProps={{ maxLength: 75 }}
          onChange={(e) => setRefferals((prev) => ({ ...prev, hospital: e.target.value }))}
          sx={{ flex: 1, ...INPUT_SIZE_SX }}
          label="Referred Hospital"
        />
      </Box>
      {/* Table */}
      <Box component="div" sx={{ height: "64dvh", overflow: "auto", borderTop: "1px solid #eee" }}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell className="billing_tbl_head" width="34%">Service Description</TableCell>
              <TableCell className="billing_tbl_head" width="5%">Units</TableCell>
              <TableCell className="billing_tbl_head" width="11%">Rate/Unit</TableCell>
              <TableCell className="billing_tbl_head" width="11%">Concession</TableCell>
              <TableCell className="billing_tbl_head" width="11%">{`Amount (${CurrencySymbol})`}</TableCell>
              {loginInfo?.is_gst_enabled && (
                <>
                  <TableCell className="billing_tbl_head" width="6.5%">GST (%)</TableCell>
                  <TableCell className="billing_tbl_head" width="11%">{`Net Amount(${CurrencySymbol})`}</TableCell>
                </>
              )}
              <TableCell className="billing_tbl_head" align="center" width="10.5%">
                <Box display="flex" justifyContent="center" alignItems="center">
                  <Typography fontSize={COMMON_STYLES.FONT_SIZE_L} fontWeight={COMMON_STYLES.FONT_WEIGHT}>Action</Typography>
                  <Tooltip title="Delete All">
                    <IconButton
                      sx={{ width: "2dvw", height: "2dvw", visibility: getCachevalue("BillType") === "Cancel" ? "hidden" : "visible" }}
                      disabled={billing.isEdit}
                      onClick={() => {
                        setBilling((prev) => ({
                          ...prev,
                          billingList: [],
                          cancelled_ids: [...prev.cancelled_ids, ...prev.billingList.map((it) => it.id).filter(Boolean)],
                          overallDiscount: { discount_amount: "", discount_percentage: "", discount_percentage_w_r: "" },
                        }));
                      }}
                    >
                      <DeleteForeverIcon color={billing.isEdit ? "disabled" : "error"} sx={{ width: "1.5dvw", height: "1.5dvw" }} />
                    </IconButton>
                  </Tooltip>
                </Box>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {billing.billingList?.length > 0 ? (
              billing.billingList.map((item, index) => {
                const serviceName = `${item?.service_name && item?.service_code ? `${item.service_name} (${item.service_code})` : item?.service_name || ""} - ${item?.service_head_name && item?.service_head_code ? `${item.service_head_name} (${item.service_head_code})` : item?.service_head_name || ""}`;
                return (
                  <TableRow key={index}>
                    <TableCell className="billing_tbl_body">
                      {serviceName?.length > 40 ? (
                        <Tooltip title={serviceName}>
                          <Typography sx={{ fontSize: COMMON_STYLES.FONT_SIZE_MD }}>{serviceName.slice(0, 40)}...</Typography>
                        </Tooltip>
                      ) : (
                        <Typography sx={{ fontSize: COMMON_STYLES.FONT_SIZE_MD }}>{serviceName}</Typography>
                      )}
                      {item?.op_order_number && (
                        <Typography sx={{ fontSize: COMMON_STYLES.FONT_SIZE_MD }}>{item.op_order_number}</Typography>
                      )}
                    </TableCell>
                    <TableCell className="billing_tbl_body">{item?.unit ?? 1}</TableCell>
                    <TableCell className="billing_tbl_body">{CommonValidation.formatAmount(item?.rate_per_unit || "")}</TableCell>
                    <TableCell className="billing_tbl_body">{CommonValidation.formatAmount(item?.concession_amt || "")}</TableCell>
                    <TableCell className="billing_tbl_body">{CommonValidation.formatAmount(item?.total_with_discount || "")}</TableCell>
                    {loginInfo?.is_gst_enabled && (
                      <>
                        <TableCell className="billing_tbl_body">{item?.gst_percent}</TableCell>
                        <TableCell className="billing_tbl_body">{CommonValidation.formatAmount(item?.service_with_gst_total_amt || "")}</TableCell>
                      </>
                    )}
                    <TableCell align="center" className="billing_tbl_body">
                      <Box sx={{ visibility: getCachevalue("BillType") === "Cancel" ? "hidden" : "visible" }}>
                        <IconButton
                          sx={{ width: "2dvw", height: "2dvw" }}
                          disabled={requestState?.fromApprover && !requestState.modifyApprover}
                          onClick={() => onEditHandler(item, index)}
                        >
                          <EditIcon color={requestState?.fromApprover && !requestState.modifyApprover ? "disabled" : "primary"} sx={{ width: "1.5dvw", height: "1.5dvw" }} />
                        </IconButton>
                        {!requestState.fromApprover && !requestState?.fromBillConvert && (
                          <IconButton
                            sx={{ width: "2dvw", height: "2dvw" }}
                            disabled={billing.isEdit}
                            onClick={() => {
                              setBilling((prev) => {
                                const list = [...prev.billingList];
                                const cancelId = list[index]?.id ? [list[index].id] : [];
                                list.splice(index, 1);
                                return {
                                  ...prev,
                                  billingList: list,
                                  cancelled_ids: [...prev.cancelled_ids, ...cancelId],
                                  overallDiscount: { discount_amount: "", discount_percentage: "", discount_percentage_w_r: "" },
                                };
                              });
                            }}
                          >
                            <DeleteForeverIcon color={billing.isEdit ? "disabled" : "error"} sx={{ width: "1.5dvw", height: "1.5dvw" }} />
                          </IconButton>
                        )}
                      </Box>
                    </TableCell>
                  </TableRow>
                );
              })
            ) : (
              <TableRow>
                <TableCell colSpan={loginInfo?.is_gst_enabled ? 9 : 7} align="center" sx={{ borderBottom: "none", position: "relative", top: "10rem" }}>
                  No Records To Be Shown
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </Box>
      {/* Service Input Bar */}
      <Box
        display="flex"
        flexWrap="nowrap"
        alignItems="center"
        gap="0.5vw"
        sx={{ px: "0.8vw", py: "0.5vh", borderTop: "1px solid #eee", minHeight: "3vw" }}
      >
        <Autocomplete
          size="small"
          sx={{ width: "9.5dvw", minWidth: 108, flexShrink: 0, ...INPUT_SIZE_SX }}
          options={billing.SpecimenList || []}
          getOptionLabel={(opt) =>
            typeof opt === "string" ? opt : `${opt?.specimen_type || "-"}${opt?.specimen_code ? ` - (${opt.specimen_code})` : ""}`
          }
          value={billing.selected_specimen ?? (billing.billingList?.[0]?.specimen_id && billing.SpecimenList?.length ? billing.SpecimenList.find((s) => s.id === billing.billingList[0].specimen_id) ?? null : null)}
          onChange={(e, newValue) => {
            if (newValue) setBilling((prev) => ({ ...prev, selected_specimen: newValue, selected_specimen_id: newValue?.id }));
            else setBilling((prev) => ({ ...prev, selected_specimen: null, selected_specimen_id: null }));
            clearService();
          }}
          disabled={billing.billingList?.length > 0 || isExistingBill}
          renderInput={(params) => <TextField {...params} label="Specimen Type" />}
        />
        <Autocomplete
          size="small"
          sx={{ width: "13dvw", minWidth: 132, flexShrink: 0, ...INPUT_SIZE_SX }}
          disabled={billing.isEdit || requestState.fromApprover}
          options={filteredServiceSugg}
          getOptionLabel={(opt) =>
            typeof opt === "string"
              ? opt
              : `${(opt?.service_head ?? opt?.service_head_name) && opt?.service_head_code ? `${opt?.service_head ?? opt?.service_head_name} (${opt.service_head_code})` : opt?.service_head ?? opt?.service_head_name} - ${opt?.service_name && opt?.service_code ? `${opt.service_name} (${opt.service_code})` : opt?.service_name || ""}`
          }
          value={billing.selected_service}
          onChange={(e, newValue) => {
            if (newValue) {
              onSelectServiceHandler(newValue);
              setSearchKey("");
            } else clearService();
          }}
          onInputChange={(e, newInputValue) => {
            if (newInputValue?.length >= 3) setSearchKey(newInputValue);
          }}
          renderInput={(params) => <TextField {...params} label="Search Service" />}
          slotProps={{ popper: { style: { width: "30dvw" } } }}
          renderOption={(props, item) => {
            const serviceName = item.service_head && item.service_head_code ? `${item.service_head} (${item.service_head_code})` : item.service_head || "";
            const serName = item.service_name && item.service_code ? `${item.service_name} (${item.service_code})` : item.service_name || "";
            const displayName = `${serviceName} ${serName}`;
            return (
              <Box {...props} key={item?.service_details_id}>
                <Tooltip title={displayName} arrow>
                  <Typography sx={{ fontSize: "0.9dvw", fontWeight: 600 }}>{displayName.length > 58 ? `${displayName.slice(0, 55)}...` : displayName}</Typography>
                </Tooltip>
                <Typography sx={{ fontSize: "0.8dvw" }}>{item?.module_type === "IP_OP" ? "IP & OP" : item?.module_type || ""}</Typography>
              </Box>
            );
          }}
        />
        <Box component="div" border="1px solid #ccc" borderRadius="4px" height="2.25vw" display="flex" alignItems="center" justifyContent="space-evenly" width="5.5vw" flexShrink={0}>
          <IconButton
            sx={{ height: "1.8vw", width: "1.8vw" }}
            disabled={+billing?.service_data?.unit === 1 || !billing?.service_data?.edit_unit}
            onClick={() => onClickUnitHandler("decrease")}
          >
            <RemoveIcon color={+billing?.service_data?.unit === 1 || !billing?.service_data?.edit_unit ? "disabled" : "primary"} sx={{ fontSize: "1vw" }} />
          </IconButton>
          <Typography fontSize="0.85vw" fontWeight={600}>
            {billing?.service_data?.unit ?? 1}
          </Typography>
          <IconButton
            disabled={!billing?.service_data?.edit_unit}
            sx={{ height: "1.8vw", width: "1.8vw" }}
            onClick={() => onClickUnitHandler("increase")}
          >
            <AddIcon color={!billing?.service_data?.edit_unit ? "disabled" : "primary"} sx={{ fontSize: "1vw" }} />
          </IconButton>
        </Box>
        {!!billing?.service_data?.doctor_amt || !!billing?.service_data?.hospital_amt || !!billing?.service_data?.is_sharable ? (
            <Button
              className="Common_Btn_Min_Width"
              sx={{ textTransform: "capitalize", height: "2.25vw", flexShrink: 0 }}
              disabled={!billing?.service_data?.edit_amount}
              endIcon={`(${CommonValidation.formatAmount(billing?.service_data?.rate_per_unit)})`}
              onClick={() => onOpenPopupHandler("rate")}
            >
            Rate/Unit
          </Button>
        ) : (
          <TextField
            autoComplete="off"
            size="small"
            InputProps={{ readOnly: !billing?.service_data?.edit_amount }}
            sx={{ width: "7dvw", ...INPUT_SIZE_SX }}
            label="Rate/Unit"
            value={billing?.service_data?.rate_per_unit ?? ""}
            onChange={(e) => withOutShareHandler(e, "rate_per_unit")}
          />
        )}
        <Box component="div" display="flex" alignItems="center" gap={0.5} flexShrink={0}>
          {!!billing?.service_data?.doctor_amt || !!billing?.service_data?.hospital_amt ? (
            <Button
              className="Common_Btn_Min_Width"
              sx={{ textTransform: "capitalize" }}
              disabled={!billing?.service_data?.edit_discount}
              endIcon={`(${CommonValidation.formatAmount(billing?.service_data?.concession_amt)})`}
              onClick={() => onOpenPopupHandler("concession")}
            >
              Concession
            </Button>
          ) : (
            <>
              <TextField
                disabled={!billing?.service_data?.edit_discount}
                autoComplete="off"
                size="small"
                sx={{ width: "6dvw", ...INPUT_SIZE_SX }}
                label={`Conc (${CurrencySymbol})`}
                value={billing?.service_data?.concession_amt != null && billing.service_data.concession_amt !== "" ? billing.service_data.concession_amt : ""}
                onChange={(e) => withOutShareHandler(e, "concession_discount_amt")}
              />
              <TextField
                disabled={!billing?.service_data?.edit_discount}
                autoComplete="off"
                size="small"
                sx={{ width: "6dvw", ...INPUT_SIZE_SX }}
                label="Conc (%)"
                value={billing?.service_data?.concession_percent_w_r != null && billing.service_data.concession_percent_w_r !== "" ? billing.service_data.concession_percent_w_r : ""}
                onChange={(e) => withOutShareHandler(e, "concession_discount_percent")}
              />
            </>
          )}
        </Box>
        <TextField
          size="small"
          sx={{ width: "7dvw", ...INPUT_SIZE_SX }}
          value={
            billing?.service_data?.total_amt != null && billing.service_data.total_amt !== ""
              ? CommonValidation.formatAmount(+billing.service_data.total_amt - +(billing.service_data.concession_amt || 0))
              : ""
          }
          InputProps={{ readOnly: true }}
          label="Total"
        />
        <IconButton sx={{ height: "2.25vw", width: "2.25vw", flexShrink: 0, backgroundColor: "primary.main", color: "white", borderRadius: "4px", "&:hover": { backgroundColor: "primary.dark" } }} onClick={onAddHandler} aria-label="Add service">
          <AddIcon sx={{ fontSize: "1.2vw" }} />
        </IconButton>
      </Box>
    </Box>
  );

  const showCashTextBox = () => (
    <Box component="div">
      <Box component="div">
        <FormControlLabel control={<Checkbox size="small" checked={paymentMode?.isCash} onChange={(e) => handleCheckBox(e, "isCash")} />} label={<Typography fontSize={COMMON_STYLES.FONT_SIZE_L}>Cash</Typography>} />
        <FormControlLabel control={<Checkbox size="small" checked={paymentMode?.isCard} onChange={(e) => handleCheckBox(e, "isCard")} />} label={<Typography fontSize={COMMON_STYLES.FONT_SIZE_L}>Card</Typography>} />
        <FormControlLabel control={<Checkbox size="small" checked={paymentMode?.isUPI} onChange={(e) => handleCheckBox(e, "isUPI")} />} label={<Typography fontSize={COMMON_STYLES.FONT_SIZE_L}>UPI</Typography>} />
        <FormControlLabel control={<Checkbox size="small" checked={paymentMode?.isBank} onChange={(e) => handleCheckBox(e, "isBank")} />} label={<Typography fontSize={COMMON_STYLES.FONT_SIZE_L}>Bank</Typography>} />
        <FormControlLabel control={<Checkbox size="small" checked={paymentMode?.isCheque} onChange={(e) => handleCheckBox(e, "isCheque")} />} label={<Typography fontSize={COMMON_STYLES.FONT_SIZE_L}>Cheque</Typography>} />
      </Box>
      <Box component="div">
        {paymentMode?.isCash && cashTextBox("cash_amt", paymentMode.cash_amt, "Cash Amount", ImagePaths.CashIcon)}
        {paymentMode?.isCard && (
          <Box display="flex">
            {cashTextBox("card_amt", paymentMode.card_amt, "Card Amount", ImagePaths.CardIcon)}
            {referenceTextBox("card_no", paymentMode.card_no)}
          </Box>
        )}
        {paymentMode?.isUPI && (
          <Box display="flex">
            {cashTextBox("upi_amt", paymentMode.upi_amt, "UPI Amount", ImagePaths.UPIIcon)}
            {referenceTextBox("upi_no", paymentMode.upi_no)}
          </Box>
        )}
        {paymentMode?.isBank && (
          <Box display="flex">
            {cashTextBox("bank_amt", paymentMode.bank_amt, "Bank Amount", ImagePaths.BankTransferIcon)}
            {referenceTextBox("bank_no", paymentMode.bank_no)}
          </Box>
        )}
        {paymentMode?.isCheque && (
          <Box display="flex">
            {cashTextBox("cheque_amt", paymentMode.cheque_amt, "Cheque Amount", ImagePaths.ChequeIcon)}
            {referenceTextBox("cheque_no", paymentMode.cheque_no)}
          </Box>
        )}
      </Box>
    </Box>
  );

  const postCreditBill = useCallback((effectivePatientId) => {
    const payload = buildBillPayload("credit", effectivePatientId);
    setIsLoader(true);
    RestAPIService.create(payload, Serviceurls.HISTOPATHOLOGY_BILLING_BILL)
      .then((res) => {
        setIsLoader(false);
        if (res?.data?.status === "success") {
          const billId = res?.data?.data?.id ?? res?.data?.id;
          setCreditType(false);
          setBillSuccessPopup({
            open: true,
            label: res?.data?.message || "Credit bill created successfully",
            billId,
          });
        } else {
          errorMessage(res?.data?.message || "Failed to create credit bill.");
        }
      })
      .catch((err) => {
        setIsLoader(false);
        errorMessage(err?.response?.data?.message || err?.message);
      });
  }, [buildBillPayload, errorMessage]);

  const handleCreditTypeDone = () => {
    if (!billing.billingList?.length) {
      errorMessage("Add at least one service to the bill");
      return;
    }
    if (patientCreditType === "corporatecredit") {
      if (!employerId) {
        errorMessage("Select Corporate Name.");
        return;
      }
      if (!employeeId || !String(employeeId).trim()) {
        errorMessage("Enter Employee ID No.");
        return;
      }
    }
    if (typeof getOrCreatePatientId === "function") {
      setIsLoader(true);
      getOrCreatePatientId()
        .then((resolvedId) => {
          if (resolvedId) {
            postCreditBill(resolvedId);
          } else {
            setIsLoader(false);
            errorMessage("Patient could not be created");
          }
        })
        .catch(() => setIsLoader(false));
      return;
    }
    if (patientId) {
      postCreditBill(patientId);
      return;
    }
    errorMessage("Please create or select a patient first");
  };

  const renderCreditTypePopup = () => (
    <Dialog open={creditType} onClose={() => setCreditType(false)} fullWidth maxWidth="sm">
      <Box component="div" className="com_billing_popup" sx={{ p: 1.5 }}>
        <Box component="div" display="flex" justifyContent="space-between" alignItems="center" borderBottom="2px solid lightgray" pb={1} mb={1.5}>
          <Typography fontSize="1dvw" fontWeight={600}>Select Credit Type</Typography>
          <IconButton onClick={() => setCreditType(false)} size="small">
            <Box component="img" src={ImagePaths.LabCloseButton?.default ?? ImagePaths.LabCloseButton} alt="close" style={{ height: "1.2vw", width: "1.2vw" }} />
          </IconButton>
        </Box>
        <RadioGroup
          row
          value={patientCreditType}
          onChange={(e) => setPatientCreditType(e.target.value)}
          sx={{ gap: 2, mb: 1.5 }}
        >
          <FormControlLabel
            value="patientcredit"
            control={<Radio size="small" />}
            label="Patient Credit"
          />
          <FormControlLabel
            value="corporatecredit"
            control={<Radio size="small" />}
            label="Corporate Credit"
          />
        </RadioGroup>
        {patientCreditType === "corporatecredit" && (
          <Box display="flex" flexWrap="wrap" gap={2} mb={1.5}>
            <FormControl size="small" sx={{ minWidth: "14vw", ...INPUT_SIZE_SX }}>
              <InputLabel>Corporate Name *</InputLabel>
              <Select
                label="Corporate Name *"
                value={employerId ?? ""}
                onChange={(e) => onEmployerIdChange?.(e.target.value)}
                MenuProps={{ style: { maxHeight: 250 } }}
              >
                <MenuItem value="">None</MenuItem>
                {corporateList.map((item, idx) => (
                  <MenuItem key={item.id ?? idx} value={item.id}>
                    {item.company_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              size="small"
              label="Employee ID No *"
              sx={{ minWidth: "14vw", ...INPUT_SIZE_SX }}
              value={employeeId || ""}
              onChange={(e) => onEmployeeIdChange?.(e.target.value.toUpperCase())}
              inputProps={{ maxLength: 20 }}
            />
          </Box>
        )}
        <Box display="flex" justifyContent="flex-end" mt={2}>
          <Button variant="contained" size="small" onClick={handleCreditTypeDone}>Done</Button>
        </Box>
      </Box>
    </Dialog>
  );


  const renderRgtContent = () => {
    const concessionApplicable = +(billing.overall_data?.concession_applicable ?? 0);
    const taxableDisplay = (+(billing.overall_data?.taxable_amount ?? 0)) - +(billing.overallDiscount?.discount_amount ?? 0);

    const summaryRow = (label, value, bold) => (
      <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ py: "0.2vw" }}>
        <Typography sx={{ fontSize: "0.8vw", fontWeight: bold ? 700 : 400, color: bold ? "#1a1a1a" : "#555", flex: "1 1 auto", minWidth: 0 }}>{label}</Typography>
        <Typography sx={{ fontSize: "0.8vw", fontWeight: bold ? 700 : 500, color: bold ? "#1a1a1a" : "#333", flexShrink: 0, textAlign: "right", minWidth: "4vw" }}>{`${CurrencySymbol} ${CommonValidation.formatAmount(value)}`}</Typography>
      </Box>
    );

    return (
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%", gap: "0.5vh" }}>
        {/* Summary Card */}
        <Box sx={{ backgroundColor: "white", borderRadius: "6px", boxShadow: "0 1px 3px rgba(0,0,0,0.08)", p: "0.6vw" }}>
          {summaryRow("Sub Amount", billing.overall_data?.sub_total)}
          {summaryRow("Concession Applicable", billing.overall_data?.concession_applicable)}

          {/* Overall Concession Row */}
          <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ py: "0.2vw" }}>
            <Typography sx={{ fontSize: "0.8vw", color: "#555", flexShrink: 0 }}>Overall Concession</Typography>
            <Box display="flex" alignItems="center" gap="0.3vw">
              <TextField
                autoComplete="off"
                size="small"
                sx={{ width: "4vw", ...INPUT_SIZE_SX }}
                disabled={getCachevalue("BillType") === "Cancel" || billing.isEdit}
                placeholder={CurrencySymbol}
                value={billing?.overallDiscount?.discount_amount ?? ""}
                onBlur={() => {}}
                onChange={(e) => {
                  const value = e.target.value;
                  if (CommonValidation.DecimalNumber(value) && ((+value >= 0 && +value <= +concessionApplicable) || value === "")) {
                    setBilling((prev) => {
                      const newDiscount = {
                        ...prev.overallDiscount,
                        discount_amount: value,
                        discount_percentage: value ? CommonValidation.getDiscountPercentage(value, concessionApplicable) : "",
                        discount_percentage_w_r: value ? CommonValidation.getDiscountPercentageWithRound(value, concessionApplicable) : "",
                      };
                      return { ...prev, overallDiscount: newDiscount };
                    });
                  }
                }}
              />
              <TextField
                autoComplete="off"
                size="small"
                sx={{ width: "4vw", ...INPUT_SIZE_SX }}
                disabled={getCachevalue("BillType") === "Cancel" || billing.isEdit}
                placeholder="%"
                value={billing?.overallDiscount?.discount_percentage_w_r ?? ""}
                onChange={(e) => {
                  const value = e.target.value;
                  if ((CommonValidation.DecimalNumber(value) && +value >= 0 && +value <= 100 && +concessionApplicable !== 0) || value === "") {
                    setBilling((prev) => {
                      const findDisAmt = CommonValidation.getDiscountAmountWithRound(value, concessionApplicable);
                      const newDiscount = {
                        ...prev.overallDiscount,
                        discount_percentage: value,
                        discount_percentage_w_r: value,
                        discount_amount: value ? findDisAmt : "",
                      };
                      return { ...prev, overallDiscount: newDiscount };
                    });
                  }
                }}
              />
              <IconButton sx={{ height: "1.8vw", width: "1.8vw" }} size="small">
                <DescriptionIcon color="primary" sx={{ fontSize: "1vw" }} />
              </IconButton>
            </Box>
          </Box>

          {summaryRow("Taxable Amount", taxableDisplay)}
          {loginInfo?.is_gst_enabled && summaryRow("GST Amount", billing.overall_data?.gst_amount)}
          {summaryRow("Round Off", billing.overall_data?.round_off)}

          {/* Payable Amount - highlighted */}
          <Box sx={{ mt: "0.3vw", pt: "0.4vw", borderTop: "1.5px solid #e0e0e0" }}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography sx={{ fontSize: "0.95vw", fontWeight: 700, color: "#1a1a1a" }}>Payable Amount</Typography>
              <Typography sx={{ fontSize: "0.95vw", fontWeight: 700, color: "primary.main" }}>{`${CurrencySymbol} ${CommonValidation.formatAmount(billing.overall_data?.payable_amt)}`}</Typography>
            </Box>
          </Box>
        </Box>

        {/* Payment Methods Card */}
        <Box sx={{ backgroundColor: "white", borderRadius: "6px", boxShadow: "0 1px 3px rgba(0,0,0,0.08)", p: "0.6vw", overflowY: "auto", height: "38dvh" }}>
          {showCashTextBox()}
        </Box>

        {/* Action Buttons */}
        <Box display="flex" flexDirection="column" gap="0.3vw">
          <Box display="flex" flexDirection="row" gap="0.3vw">
            <Button
              variant="contained"
              fullWidth
              disableElevation
              sx={{ height: "2.25vw", textTransform: "capitalize", fontSize: "0.85vw", fontWeight: 600, borderRadius: "4px" }}
              disabled={!fullAmountEntered()}
              onClick={() => handleReceivePayment()}
            >
              Receive Payment
            </Button>
            <Button
              variant="outlined"
              fullWidth
              color="secondary"
              sx={{ height: "2.25vw", textTransform: "capitalize", fontSize: "0.85vw", borderRadius: "4px" }}
              onClick={() => setCreditType(true)}
            >
              Credit Bill
            </Button>
          </Box>
          <Button
            variant="outlined"
            fullWidth
            sx={{ height: "2.25vw", textTransform: "capitalize", fontSize: "0.85vw", borderRadius: "4px" }}
            onClick={() => onBillSuccessClear?.()}
          >
            Clear
          </Button>
        </Box>
        {renderCreditTypePopup()}
      </Box>
    );
  };

  return (
    <Box component="div" sx={{ overflow: "hidden" }}>
      <Grid container spacing={0} sx={{ height: "100%" }}>
        <Grid item xs={8.5} sx={{ display: "flex", flexDirection: "column" }}>
          <Box component="div" sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
            {renderLftContent()}
          </Box>
        </Grid>
        <Grid item xs={3.5}>
          <Box sx={{ pl: "0.5vw" }}>
            {renderRgtContent()}
          </Box>
        </Grid>
      </Grid>
      {message.isErrorMsg && <ToastMsg severity="error" msg={message.isErrorMsgText} msgPop={msgClose} />}
      {message.successMsg && <ToastMsg severity="success" msg={message.successMsgText} msgPop={msgClose} />}
      {billSuccessPopup.open && (
        <Modal open>
          <Box component="div" className="eMed_Bill_Success_Preview_Main">
            <img
              className="eMed_Bill_Success_animation"
              src={ImagePaths.SuccessAnimationGif?.default ?? ImagePaths.SuccessAnimationGif}
              alt="Success"
            />
            <Typography fontWeight={600}>{billSuccessPopup.label}</Typography>
            <Box display="flex" width="100%" justifyContent="center" alignItems="center" gap={1.5} padding="1vw" flexWrap="wrap">
              <Button
                size="small"
                variant="contained"
                sx={{ textTransform: "capitalize", minWidth: "7dvw" }}
                onClick={handleBillPrint}
                disabled={billSuccessPopup.billId == null || billSuccessPopup.billId === ""}
              >
                Print Bill
              </Button>
              <Button
                size="small"
                variant="outlined"
                sx={{ textTransform: "capitalize", minWidth: "7dvw" }}
                onClick={() => {
                  setBillSuccessPopup({ open: false, label: "" });
                  onBillSuccessClear?.();
                }}
              >
                Close
              </Button>
            </Box>
          </Box>
        </Modal>
      )}
      <Loader loaderOpen={isLoader} />
    </Box>
  );
}
